import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ShowDateFormatService {

  formatDate(value: string, outputFormat: string = 'dd-MM-yyyy'): string {

    const iso = new Date(value);
    if (!isNaN(iso.getTime())) {
      return this.formatOutput(iso, outputFormat);
    }

    // Known patterns
    const patterns = [
      { regex: /^(\d{2})-(\d{2})-(\d{4})$/, map: ['dd', 'MM', 'yyyy'] },
      { regex: /^(\d{4})-(\d{2})-(\d{2})$/, map: ['yyyy', 'MM', 'dd'] },
      { regex: /^(\d{2})\/(\d{2})\/(\d{4})$/, map: ['dd', 'MM', 'yyyy'] },
      { regex: /^(\d{2})\.(\d{2})\.(\d{4})$/, map: ['dd', 'MM', 'yyyy'] },
      { regex: /^(\d{4})\/(\d{2})\/(\d{2})$/, map: ['yyyy', 'MM', 'dd'] },
      { regex: /^(\d{4})\.(\d{2})\.(\d{2})$/, map: ['yyyy', 'MM', 'dd'] }
    ];

    for (const p of patterns) {
      const m = value.match(p.regex);
      if (m) {
        const date = this.buildDate(m, p.map);
        if (date) return this.formatOutput(date, outputFormat);
      }
    }

    return 'Invalid date';
  }

  private buildDate(m: RegExpMatchArray, map: string[]) {
    const obj: any = {};
    map.forEach((key, i) => obj[key] = Number(m[i + 1]));
    return new Date(obj['yyyy'], obj['MM'] - 1, obj['dd']);
  }

  private formatOutput(date: Date, format: string): string {
    const dd = this.pad(date.getDate());
    const MM = this.pad(date.getMonth() + 1);
    const yyyy = date.getFullYear();

    return format
      .replace('dd', dd)
      .replace('MM', MM)
      .replace('yyyy', String(yyyy));
  }

  private pad(n: number): string {
    return n < 10 ? '0' + n : String(n);
  }
}
